import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeQueryArgs: null
};

export const transferSlice = createSlice({
  name: 'transfers',
  initialState,
  reducers: {
    setActiveTransferQueryArgs(state, action) {
      state.activeQueryArgs = action.payload;
    }
  }
});

export const { setActiveTransferQueryArgs } = transferSlice.actions;

export default transferSlice.reducer;